import React from 'react';
import LocalizedMessage from 'react-l10n';

class RefineResultsButton extends React.Component {
    render() {
        return (
            <button
                type='button'
                className='button button-filter'
                onClick={this.props.onClick}
            >
                <span className='icon icon-filter' />
                <span className='visible-xs-inline-block'>
                    <LocalizedMessage id={'REFINE_RESULTS.MOBILE'} />
                </span>
                <span className='hidden-xs'>
                    <LocalizedMessage id={'REFINE_RESULTS.DESKTOP'} />
                </span>
            </button>
        );
    }
}

// default props
RefineResultsButton.defaultProps = {};
// validate props
RefineResultsButton.propTypes = {};

export default RefineResultsButton;
